<div class="profile-container">
    <!-- Header -->
    <div class="profile-header">
        <div class="header-content">
            <button class="btn-back" (click)="goBack()">
                <i class="pi pi-arrow-left"></i>
                Volver
            </button>
            <div class="header-info" *ngIf="profile?.company">
                <div class="company-icon">
                    <i class="pi pi-building"></i>
                </div>
                <div class="company-details">
                    <h1>{{ profile?.company?.name }}</h1>
                    <p class="company-document">NIT: {{ profile?.company?.documentId }}</p>
                    <p class="company-contact" *ngIf="profile?.company?.email">
                        <i class="pi pi-envelope"></i> {{ profile?.company?.email }}
                    </p>
                </div>
            </div>
            <div class="header-actions">
                <button class="btn-secondary" (click)="editCompany()">
                    <i class="pi pi-pencil"></i>
                    Editar Empresa
                </button>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
        <i class="pi pi-spin pi-spinner"></i>
        <p>Cargando perfil...</p>
    </div>

    <!-- Content -->
    <div class="profile-content" *ngIf="!isLoading && profile">
        <!-- Financial Summary Cards -->
        <div class="summary-cards">
            <div class="summary-card">
                <div class="card-icon enrollments">
                    <i class="pi pi-book"></i>
                </div>
                <div class="card-content">
                    <span class="card-value">{{ profile.financialSummary?.activeEnrollments || 0 }}</span>
                    <span class="card-label">Inscripciones Activas</span>
                </div>
            </div>
            <div class="summary-card">
                <div class="card-icon participants">
                    <i class="pi pi-users"></i>
                </div>
                <div class="card-content">
                    <span class="card-value">{{ profile.financialSummary?.totalParticipants || 0 }}</span>
                    <span class="card-label">Participantes</span>
                </div>
            </div>
            <div class="summary-card">
                <div class="card-icon total">
                    <i class="pi pi-dollar"></i>
                </div>
                <div class="card-content">
                    <span class="card-value">{{ formatCurrency(profile.financialSummary?.totalCompanyAmount || 0)
                        }}</span>
                    <span class="card-label">Total Comprometido</span>
                </div>
            </div>
            <div class="summary-card">
                <div class="card-icon paid">
                    <i class="pi pi-check-circle"></i>
                </div>
                <div class="card-content">
                    <span class="card-value">{{ formatCurrency(profile.financialSummary?.paidByCompany || 0) }}</span>
                    <span class="card-label">Pagado</span>
                </div>
            </div>
            <div class="summary-card">
                <div class="card-icon pending">
                    <i class="pi pi-clock"></i>
                </div>
                <div class="card-content">
                    <span class="card-value">{{ formatCurrency(profile.financialSummary?.pendingByCompany || 0)
                        }}</span>
                    <span class="card-label">Pendiente</span>
                </div>
            </div>
        </div>

        <!-- Tabs -->
        <div class="tabs-container">
            <div class="tabs">
                <button class="tab" [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')">
                    <i class="pi pi-chart-bar"></i>
                    Resumen
                </button>
                <button class="tab" [class.active]="activeTab === 'enrollments'" (click)="setActiveTab('enrollments')">
                    <i class="pi pi-book"></i>
                    Inscripciones Corporativas
                </button>
                <button class="tab" [class.active]="activeTab === 'participants'"
                    (click)="setActiveTab('participants')">
                    <i class="pi pi-users"></i>
                    Participantes Patrocinados
                </button>
            </div>
        </div>

        <!-- Tab Content: Overview -->
        <div class="tab-content" *ngIf="activeTab === 'overview'">
            <div class="section">
                <h2>Información de la Empresa</h2>
                <div class="info-grid">
                    <div class="info-item">
                        <span class="label">Nombre</span>
                        <span class="value">{{ profile.company?.name || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">NIT/Documento</span>
                        <span class="value">{{ profile.company?.documentId || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Email</span>
                        <span class="value">{{ profile.company?.email || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Teléfono</span>
                        <span class="value">{{ profile.company?.phone || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Dirección</span>
                        <span class="value">{{ profile.company?.address || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Contacto</span>
                        <span class="value">{{ profile.company?.contactName || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tab Content: Enrollments -->
        <div class="tab-content" *ngIf="activeTab === 'enrollments'">
            <div class="section" *ngIf="(profile?.corporateEnrollments?.length || 0) > 0; else noEnrollments">
                <div class="enrollment-list">
                    <div class="enrollment-item" *ngFor="let enrollment of profile.corporateEnrollments"
                        [class.expanded]="isEnrollmentExpanded(enrollment.id)">
                        <div class="enrollment-header" (click)="toggleEnrollment(enrollment.id)">
                            <div class="enrollment-info">
                                <span class="project-name">{{ enrollment.projectName }}</span>
                                <span class="enrollment-badge" [ngClass]="getStatusClass(enrollment.status)">
                                    {{ getStatusLabel(enrollment.status) }}
                                </span>
                            </div>
                            <div class="enrollment-meta">
                                <span class="participants-count">
                                    <i class="pi pi-users"></i> {{ enrollment.participants?.length || 0 }} participantes
                                </span>
                                <span class="enrollment-amount">{{ formatCurrency(enrollment.totalAmount) }}</span>
                                <i class="pi"
                                    [ngClass]="isEnrollmentExpanded(enrollment.id) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                            </div>
                        </div>

                        <!-- Expanded Content -->
                        <div class="enrollment-details" *ngIf="isEnrollmentExpanded(enrollment.id)">
                            <div class="details-grid">
                                <div class="detail-item">
                                    <span class="label">Cobertura por Defecto</span>
                                    <span class="value">{{ enrollment.defaultCompanyCoveragePercent }}%</span>
                                </div>
                                <div class="detail-item">
                                    <span class="label">Moneda</span>
                                    <span class="value">{{ enrollment.currencyCode || 'COP' }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="label">Fecha Inicio</span>
                                    <span class="value">{{ formatDate(enrollment.startDate) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="label">Fecha Fin</span>
                                    <span class="value">{{ formatDate(enrollment.endDate) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="label">Monto Pagado</span>
                                    <span class="value paid">{{ formatCurrency(enrollment.paidAmount) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="label">Monto Pendiente</span>
                                    <span class="value pending">{{ formatCurrency(enrollment.pendingAmount) }}</span>
                                </div>
                            </div>

                            <!-- Company Payment Plans -->
                            <div class="payment-plans-section" *ngIf="enrollment.companyPaymentPlans?.length > 0">
                                <h4>Plan de Pagos de la Empresa</h4>
                                <table class="payment-plans-table">
                                    <thead>
                                        <tr>
                                            <th>Cuota</th>
                                            <th>Fecha Vencimiento</th>
                                            <th>Monto</th>
                                            <th>Pendiente</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let plan of enrollment.companyPaymentPlans">
                                            <td>{{ plan.installmentNumber }}</td>
                                            <td>{{ formatDate(plan.dueDate) }}</td>
                                            <td>{{ formatCurrency(plan.totalValue) }}</td>
                                            <td>{{ formatCurrency(plan.pendingPayment) }}</td>
                                            <td>
                                                <span class="status-badge"
                                                    [ngClass]="getPaymentStatusClass(plan.paymentStatus)">
                                                    {{ plan.paymentStatusLabel }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Participants in this enrollment -->
                            <div class="participants-section" *ngIf="enrollment.participants?.length > 0">
                                <h4>Participantes en esta Inscripción</h4>
                                <table class="participants-table">
                                    <thead>
                                        <tr>
                                            <th>Participante</th>
                                            <th>Documento</th>
                                            <th>Tipo Cobertura</th>
                                            <th>Cobertura</th>
                                            <th>Total</th>
                                            <th>Pagado</th>
                                            <th>Pendiente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let participant of enrollment.participants">
                                            <td>
                                                <div class="participant-info">
                                                    <span class="name">{{ participant.participantName }}</span>
                                                    <span class="email">{{ participant.participantEmail }}</span>
                                                </div>
                                            </td>
                                            <td>{{ participant.participantDocument }}</td>
                                            <td>{{ getCoverageTypeLabel(participant.coverageType) }}</td>
                                            <td>
                                                <span *ngIf="participant.coverageType === 1">{{
                                                    participant.companyCoveragePercent }}%</span>
                                                <span *ngIf="participant.coverageType === 2">{{
                                                    formatCurrency(participant.companyCoverageAmount) }}</span>
                                                <span *ngIf="participant.coverageType === 0">-</span>
                                            </td>
                                            <td>{{ formatCurrency(participant.totalAmount) }}</td>
                                            <td class="paid">{{ formatCurrency(participant.paidAmount) }}</td>
                                            <td class="pending">{{ formatCurrency(participant.pendingAmount) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noEnrollments>
                <div class="empty-state">
                    <i class="pi pi-inbox"></i>
                    <p>No hay inscripciones corporativas registradas</p>
                </div>
            </ng-template>
        </div>

        <!-- Tab Content: All Participants -->
        <div class="tab-content" *ngIf="activeTab === 'participants'">
            <div class="section">
                <ng-container *ngIf="getUniqueParticipants() as participants">
                    <table class="participants-table" *ngIf="participants.length > 0; else noParticipants">
                        <thead>
                            <tr>
                                <th>Participante</th>
                                <th>Documento</th>
                                <th>Email</th>
                                <th>Proyecto</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let enrollment of profile.corporateEnrollments">
                                <tr *ngFor="let participant of enrollment.participants">
                                    <td>{{ participant.participantName }}</td>
                                    <td>{{ participant.participantDocument }}</td>
                                    <td>{{ participant.participantEmail }}</td>
                                    <td>{{ enrollment.projectName }}</td>
                                    <td>
                                        <span class="status-badge"
                                            [ngClass]="participant.isActive ? 'active' : 'inactive'">
                                            {{ participant.isActive ? 'Activo' : 'Inactivo' }}
                                        </span>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <ng-template #noParticipants>
                        <div class="empty-state">
                            <i class="pi pi-users"></i>
                            <p>No hay participantes patrocinados</p>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>